import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("helpCenter",
      [
        "error",
        "success",
        "loading"
      ]
    )
  }
};
